import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";

import "./EventsTable.html";
import "./EventsTable.scss";

import EventsTableComponentController from "./EventsTableComponentController";
import "./EventsTableDetails/EventsTableDetailsComponent";

export default class EventsTableComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            eventsTableEntries: "<",
            site: "<",
        };

        this.controller = EventsTableComponentController;
        this.templateUrl = "/App/Components/Site/Events/EventsTable/EventsTable.html";
    }
}

module("mmGui").component("irEventsTable", new EventsTableComponent());
